<template>
  <div
    class="HTML_BAR_INDICATOR_ITEM workspace_theme"
    ref="workspace_theme"
    :class="[sizeClassName, draggableStatus]"
  >
    <img
      v-if="fileData.posterBgImageUrlBase64"
      class="workspace_theme_bg"
      :src="fileData.posterBgImageUrlBase64"
    />

    <template v-if="fileData.fileList && fileData.fileList.length > 0">
      <span
        class="picContainer"
        v-for="picItem in fileData.fileList"
        :key="picItem.uid"
        :class="[
          picItem.className,
          picItem.actState,
          picItem.isShowPic ? '' : 'displayNone',
        ]"
        :style="picItem.styleItem"
      >
        <DraggableImageItem
          :currThemeObj="currThemeObj"
          :picItem="picItem"
          :cssDynamicObj="cssDynamicObj"
        ></DraggableImageItem>
      </span>
    </template>

    <img
      v-if="fileData.posterLImageUrlBase64"
      class="workspace_theme_bg posterLImage"
      :src="fileData.posterLImageUrlBase64"
    />

    <span class="titleName" v-text="fileData.titleName"></span>
    <span
      class="renderDataDom"
      :class="
        themeItemData.renderData &&
        themeItemData.renderData.statisticsModels &&
        themeItemData.renderData.statisticsModels.length === 2
          ? 'twoColumn'
          : ''
      "
    >
      <span class="tableBox">
        <span
          class="rowItem"
          v-for="(row, rowIndex) in renderList"
          :key="rowIndex"
          :class="rowIndex === 0 ? 'header' : ''"
        >
          <span
            class="rowItem_column"
            v-for="(column, columnIndex) in row"
            :key="column.key"
            :class="[
              columnIndex === 0 ? 'firstColumn' : '',
              column && column.length > 8 ? 'smallFont' : '',
              column.high ? 'isHigh' : '',
            ]"
            v-text="column.name"
          ></span>
        </span>
      </span>
    </span>
  </div>
</template>
<script>
// 数据海报中的 指标项主题
import dataPoster_themeItem_comBase_mixin from '@mixins/dataPoster_themeItem_comBase'
export default {
  name: 'HTML_BAR_INDICATOR_ITEM',
  mixins: [dataPoster_themeItem_comBase_mixin],

  data() {
    return {}
  },
  methods: {
    makePosterIdDatas(posterId, renderData) {
      // 每个主题中自定义组装数据逻辑
      let tableHeader = []
      let tableData = []
      if ([10].includes(posterId)) {
        // 单照片
        console.debug('单照片表格技术统计')
        const dataList =
          renderData.data && renderData.data.dataList
            ? renderData.data.dataList
            : []
        tableHeader.push(
          renderData.statisticsModels.map((keyItem) => {
            return {
              key: keyItem.statisticalEn,
              name: keyItem.name,
              high: '', //表头固定空
            }
          })
        )
        tableData = dataList.map((dataItem) => {
          let rowValArr = []
          renderData.statisticsModels.forEach((keyItem, keyIndex) => {
            rowValArr.push({
              key: keyItem.statisticalEn,
              name: this._valFormatHandler(
                dataItem[keyItem.statisticalEn],
                '-',
                keyItem.suffix
              ),
              high: keyItem.high ? dataItem[keyItem.high] : '',
            })
          })
          return rowValArr
        })
      }
      console.debug('renderList:', tableHeader, tableData)
      return [].concat(tableHeader, tableData) //这里最后返回的就是 renderList
    },
  },
}
</script>
<style lang="scss" scoped>
.HTML_BAR_INDICATOR_ITEM {
  &.workspace_theme {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: left top;
    &.touchmove_open {
      .picContainer {
        pointer-events: none;
        &.click {
          pointer-events: all;
        }
      }
    }
    .workspace_theme_bg {
      position: relative;
      display: block;
      width: 100%;
      height: 100%;
      pointer-events: none;
    }
    .posterLImage {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 120;
      width: 100;
      height: 100%;
    }
    .picContainer {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      z-index: 100;
      overflow: hidden;
      cursor: move !important;
      &:hover {
        cursor: move !important;
      }
      &.displayNone {
        display: none;
      }
    }
    &.horizontalScreen {
      /* 横版 */
      &.singlePlayer {
        .renderDataDom {
          top: 14%;
          left: 20.416%;
          width: 50.125%;
          height: calc(
            (7 * 4vw + 6 * 0.3125vw) * var(--mixtmt_dataPoster_mixvw)
          );
          &.twoColumn {
            top: 10%;
            left: 28%;
            width: 36.04%;
            height: calc(
              (7 * 4.375vw + 6 * 0.3125vw) * var(--mixtmt_dataPoster_mixvw)
            );
            .tableBox {
              .rowItem {
                height: calc(4.375vw * var(--mixtmt_dataPoster_mixvw));
              }
            }
          }
        }
      }
      .titleName {
        left: calc(10.104vw * var(--mixtmt_dataPoster_mixvw));
        top: 0;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: calc(7.76vw * var(--mixtmt_dataPoster_mixvw));
        height: 67.41%;
        font-size: calc(4.896vw * var(--mixtmt_dataPoster_mixvw));
        line-height: calc(5.6vw * var(--mixtmt_dataPoster_mixvw));
        color: var(--mixtmt_dataPoster_titleNameColor);
        /* font-weight: bold; */
        text-align: center;
      }
    }
    .renderDataDom {
      position: absolute;
      z-index: 150;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      transition: width 0.3s linear;
      -webkit-transition: width 0.3s linear;
      /* pointer-events: none; */
      .tableBox {
        position: relative;
        width: 100%;
        height: auto;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .rowItem {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          height: calc(4vw * var(--mixtmt_dataPoster_mixvw));
          margin-top: calc(0.3125vw * var(--mixtmt_dataPoster_mixvw));
          &.header {
            margin-top: 0;
            .rowItem_column,
            .rowItem_column.firstColumn {
              border: 1px solid var(--mixtmt_dataPoster_tableTitleBorderColor);
              border-radius: 0;
              color: var(--mixtmt_dataPoster_tableTitleColor);
              background: -moz-linear-gradient(
                -180deg,
                var(--mixtmt_dataPoster_tableTitleRowBgLGColor1) 0%,
                var(--mixtmt_dataPoster_tableTitleRowBgLGColor2) 100%
              );
              background: -webkit-gradient(
                left top,
                right bottom,
                color-stop(
                  0%,
                  var(--mixtmt_dataPoster_tableTitleRowBgLGColor1)
                ),
                color-stop(
                  100%,
                  var(--mixtmt_dataPoster_tableTitleRowBgLGColor2)
                )
              );
              background: -webkit-linear-gradient(
                -180deg,
                var(--mixtmt_dataPoster_tableTitleRowBgLGColor1) 0%,
                var(--mixtmt_dataPoster_tableTitleRowBgLGColor2) 100%
              );
              background: -o-linear-gradient(
                -180deg,
                var(--mixtmt_dataPoster_tableTitleRowBgLGColor1) 0%,
                var(--mixtmt_dataPoster_tableTitleRowBgLGColor2) 100%
              );
              background: -ms-linear-gradient(
                -180deg,
                var(--mixtmt_dataPoster_tableTitleRowBgLGColor1) 0%,
                var(--mixtmt_dataPoster_tableTitleRowBgLGColor2) 100%
              );
              background: linear-gradient(
                180deg,
                var(--mixtmt_dataPoster_tableTitleRowBgLGColor1) 0%,
                var(--mixtmt_dataPoster_tableTitleRowBgLGColor2) 100%
              );
              /* background-color: rgba(25, 53, 103, 1); */
            }
          }
          /* &:last-child {
            border-bottom: 0;
          } */
          .rowItem_column {
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            flex: 1;
            height: 100%;
            background: var(--mixtmt_dataPoster_tableValBgColor);
            font-size: calc(1.4vw * var(--mixtmt_dataPoster_mixvw));
            color: var(--mixtmt_dataPoster_tableValColor);
            border-radius: calc(0.694vw * var(--mixtmt_dataPoster_mixvw));
            border: 1px solid var(--mixtmt_dataPoster_tableValBorderColor);
            text-align: center;
            &.smallFont {
              font-size: calc(1.2vw * var(--mixtmt_dataPoster_mixvw));
            }
            &.firstColumn {
              background: var(--mixtmt_dataPoster_tableTitleColBgColor);
              color: var(--mixtmt_dataPoster_tableTitleColor);
              border: 1px solid
                var(--mixtmt_dataPoster_tableFirstColumnBorderColor);
            }
            &.isHigh {
              background: var(--mixtmt_dataPoster_columnItemHightBgColor);
            }
            /* &:first-child {
              border-left: 0;
            } */
          }
        }
      }
    }
    .titleName {
      position: absolute;
      z-index: 130;
      pointer-events: none;
    }
  }
}
</style>
